<script setup>
const store = useEventsStore();
const activeDropDownItem = computed(() => store.activeDropDownItem);
const dropDownIsOpen = computed(() => store.dropDownIsOpen);
const { setDropDownItem, closeDropDown, toggleDropDown } = store;

const { t } = useI18n();

const props = defineProps(['text', 'color']);
const alignToRight = ref(false);

const elemRef = ref(null);

const buttonColor = computed(() => {
  return props.color ? `button--${props.color}` : 'button--white';
});

onMounted(() => {
  checkAlignment();
});

const resetState = () => {
  closeDropDown();
  setDropDownItem(null);
};

const checkAlignment = () => {
  const { x, width } = elemRef.value.getBoundingClientRect();
  alignToRight.value = x + width >= window.innerWidth;
};
</script>

<template>
  <div class="dropdown" :class="{ 'is-open': dropDownIsOpen }" v-click-outside="closeDropDown">
    <div class="dropdown__button" @click="toggleDropDown" @keyup.enter="toggleDropDown">
      <slot name="button">
        <button class="button button--small" :class="[buttonColor]">
          <span>{{ activeDropDownItem?.name || 'building' }}</span>
          <i class="dropdown__arrow" />
        </button>
      </slot>
    </div>
    <div ref="elemRef" class="dropdown__elem" :class="{ 'dropdown__elem--right': alignToRight }">
      <slot />
      <button v-if="activeDropDownItem" class="dropdown__cancel" @click="resetState" @keyup.enter="resetState">
        {{ t('global.dropdown-cancel') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dropdown {
  $s: &;
  position: relative;

  &__button {
    user-select: none;
  }

  &__elem {
    position: absolute;
    z-index: 2;
    top: 100%;
    left: 0;
    margin-top: 7px;
    padding: 16px;
    border: 1px solid $black;
    background-color: $alabaster;
    opacity: 0;
    user-select: none;
    pointer-events: none;

    &--right {
      left: auto;
      right: 0;
    }
  }

  &__cancel {
    margin-top: 1.5em !important;
    font-size: 12px !important;
    text-align: left !important;
    cursor: pointer !important;
    @include button-reset;
  }

  &__arrow {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
    transition: transform 300ms;
    @include triangle(currentColor, down, 5px);
  }

  &.is-open {
    #{$s}__elem {
      opacity: 1;
      pointer-events: all;
    }

    #{$s}__arrow,
    .tabs__arrow {
      transform: scaleY(-1);
    }
  }
}
</style>
